import * as React from "react";

export interface IPersonalData {
	userRole: string;
	senderData?: {
		sender_name?: string;
		sender_email?: string;
		sender_phone?: string;
	};
}

const PersonalData = (props: IPersonalData): JSX.Element => {
	const { userRole, senderData } = props;
	if (
		userRole !== "verificator" ||
		(!senderData.sender_name && !senderData.sender_email && !senderData.sender_phone)
	) {
		return <div />;
	}
	return (
		<div className="personal-data">
			<div className="personal-data__item">Анкету редактировал:</div>
			<div className="personal-data__item">{senderData.sender_name || "Имя не указано"}</div>
			<div className="personal-data__item">{senderData.sender_email || "E-mail не указан"}</div>
			<div className="personal-data__item">{senderData.sender_phone || "Телефон не указан"}</div>
		</div>
	);
};

export default PersonalData;
